<template>
  <div class="navbar" v-if="visible" :class="cls" :style="styleObj">
    <a class="navbar-left navbar-btn action-back" v-if="back" @click.prevent="$router.back()"></a>
    <h1 class="navbar-title">
      <slot name="title"></slot>
    </h1>
    <slot name="right"></slot>
    <slot name="subbar"></slot>
  </div>
</template>

<script>
  export default {
    props: {
      back: {
        type: Boolean,
        default: false
      },
      transparent: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      bg: {
        type: Boolean,
        default: false
      },
      styleObj: {
        type: [Object, String]
      }
    },
    data () {
      return {
        visible: false,
        cls: {
          'navbar-transparent': this.transparent,
          'navbar-fixed': this.fixed,
          'navbar-bg': this.bg
        }
      }
    },
    created () {
      this.visible = !this.$device.isWechat
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import '../../common/css/mixmin'

  .navbar
    position relative
    z-index 100
    height px2rem(88px)
    overflow hidden
    padding-left 10px
    padding-right 10px
    background-color #275482
    border-bottom 0
    backface-visibility hidden

    &.navbar-transparent
      background-color transparent

    &.navbar-bg
      background url(../../../static/images/bg-navbar.jpg) no-repeat top left
      background-size 100% auto

    &.navbar-fixed
      position absolute
      left 0
      right 0
      top 0
      box-shadow 0 0 10px rgba(39,84,130,.75)

      & ~ .page-content
        top px2rem(88px)

    .navbar-title
      position absolute
      left px2rem(80px)
      right px2rem(80px)
      margin 0
      ellipsis()
      line-height px2rem(88px)
      font-size px2rem(32px)
      font-weight normal
      color #fff
      text-align center
      letter-spacing px2rem(1)

    .navbar-left
      float left

    .navbar-right
      float right

    .navbar-btn
      display inline-block
      padding 0 px2rem(20px)
      line-height px2rem(88px)
      color #fff
      font-size px2rem(32px)

    .action-back
      margin-left px2rem(-10px)
      font-family 'iconfont'

      &:before
        content '\e65b'
</style>



// WEBPACK FOOTER //
// navbar.vue?650d2024